import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UpdateClientUserRoleRequest } from '../_models/admin/update-client-user-role-request.model';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base/base.service';
import { SessionUserHashManagerService } from './session-user-hash-manager/session-user-hash-manager.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RoleService extends BaseService {
  
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  GetRoles(roleType) {
    return this.http.get(this.apiUrl + 'api/Roles/GetRoles?roleType=' + roleType, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetRoles'))
    );
  }

  GetClientRoles() {
    return this.http.get(this.apiUrl + 'api/Roles/GetClientRoles', this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetClientRoles'))
    );
  }

  GetClients(roleType) {
    return this.http.get(this.apiUrl + 'api/Clients/GetClients?roleType=' + roleType, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetClients'))
    );
  }

  GetRolesByUser(userId) {
    return this.http.get(this.apiUrl + 'api/Roles/GetRolesByUser?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetRolesByUser'))
    );
  }

  updateUserClientRole(request: UpdateClientUserRoleRequest) {
    return this.http.post(this.apiUrl + 'api/Roles/UpdateRole', request, this.prepareOptions(request)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('updateUserClientRole'))
    );
  }

}
